export enum PERMISSIONS {
  NOT_LOGIN = 1 << 0, // 不需登入即可訪問
}

export enum LAYOUT {
  NONE = 0, // 無 layout
  PC_SIDEBAR = 1 << 0, // pc 側邊欄
  H5_SIDEBAR = 1 << 1, // h5 側邊欄
  H5_HEADER = 1 << 2, // h5 頂部欄
}

// pc 預設 layout
export const PcDedaultLayout = LAYOUT.PC_SIDEBAR
// h5 預設 layout
export const H5DefaultLayout = LAYOUT.H5_HEADER | LAYOUT.H5_SIDEBAR
